// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world

$w.onReady(function () {
	// Write your JavaScript here
	// To select an element by ID use: $w("#elementID")

	// Click "Preview" to run your code

	

	// $w("#vectorImage1").hide();
	// $w("#html1").hide();

	$w("#vectorImage1").onClick(()=>{
		$w("#vectorImage1").hide();
		$w("#html1").hide();
	})

	$w("#image12").onClick(()=>{
		$w("#vectorImage1").show();
		$w("#html1").show();
	})

});